<template>
  <div>
    <CartSkeleton v-if="isLoading" />
    <div v-else>
      <div v-if="cartItems.length === 0" class="row">
        <div class="col">
          <p class="text-center text-muted pt-4">Cart Empty</p>
        </div>
      </div>
      <ul v-else class="list-unstyled">
        <CartItem
          ref="cartItems"
          v-for="(cartItem, index) in processedCartItems"
          :key="`${cartItem + index}`"
          :cartItem="cartItem"
          :index="index"
          :readonly="readonly"
          :hideExtraFormFields="hideExtraFormFields"
          @errorEmmited="verifyAllCartItemsAreErrorFree"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CartItem from "./CartItem.vue";
import CartSkeleton from "./CartSkeleton";
import _ from "lodash";
export default {
  name: "Cart",
  components: {
    CartItem,
    CartSkeleton,
  },
  props: {
    readonly: {
      required: false,
      type: Boolean,
    },
    hideExtraFormFields: {
      type: Boolean,
      default: false,
    },
    refreshCart: Number,
  },
  data() {
    return {
      isLoading: true,
      cartItemMap: new Map(),
    };
  },
  watch: {
    refreshCart: {
      immediate: true,
      handler() {
        this.initialize();
      },
    },
  },
  computed: {
    ...mapGetters("cart", [
      "cartItems",
      "totalPackageCost",
      "totalAddOnCost",
      "cartTotal",
      "processedCartItems",
    ]),
  },
  mounted() {
    this.initialize();
  },
  methods: {
    touchValidationOfAllCartItems() {
      if (this.cartItems.length && !this.hideExtraFormFields) {
        return new Promise((resolve) => {
          const isAnyCartItemNotTouched = this.$refs.cartItems.some(
            (item) => item.$refs.packageOwnerForm?.itemIsTouched == false
          );
          if (isAnyCartItemNotTouched) {
            this.$refs.cartItems.forEach((item) => {
              if (item.$refs.packageOwnerForm?.itemIsTouched == false) {
                item.$refs.packageOwnerForm?.v$.cartItemOwner.$touch();
              }
            });
          }
          this.verifyAllCartItemsAreErrorFree();
          resolve(true);
        });
      } else {
        return false;
      }
    },
    verifyAllCartItemsAreErrorFree() {
      this.$nextTick(() => {
        const itemHasErrors = this.$refs.cartItems.some(
          (item) => item.$refs.packageOwnerForm?.v$.$error
        );
        this.$emit("packageOwnerFormHasErrors", itemHasErrors);
      });
    },
    extractPackageOwnersInfo() {
      let packageOwners = [];
      const parentCartItems = this.$refs.cartItems?.filter(
        (item) => item.hasNoLinkedItems || item.showFormAfterLinkedItems
      );

      parentCartItems.map((item, index) => {
        const payload = {
          index: index,
          self: item.$refs.packageOwnerForm?.self,
        };
        if (payload.self === false) {
          const ownerData = item.$refs.packageOwnerForm?.cartItemOwner;
          payload.ownerData = { ...ownerData };
        }
        packageOwners.push(payload);
      });
      return packageOwners;
    },
    async initialize() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("cart/getCart");
      } catch (error) {
        this.$bvToast.toast(error.message, { variant: "danger" });
      }
      this.isLoading = false;
    },
  },
};
</script>
